/**
 * "View cancellation & refund details" 에 넣을 내용을 고른다.
 *
 * 장바구니(My bag)와 Check details 는 워크숍이 여러 개 섞일 수 있어 하나의 문자열로 합친다.
 * - 전용 정책이 있는 워크숍이 하나도 없으면 '' → 모달이 기본 Koready 정책을 보여준다
 * - 전용 정책이 있는 워크숍이 하나뿐이면 그 정책 그대로
 * - 여럿이면 워크숍 제목을 `#` 제목으로 붙여 이어 붙인다 (모달의 마크다운 렌더러가 제목으로 그린다).
 *   전용 정책이 없는 워크숍은 "기본 정책을 따른다" 한 줄로 표시해 빠졌다는 오해가 없게 한다.
 *
 * @param {Array<{ workshopId?: number|string, title?: string, refundPolicy?: string }>} workshops
 * @returns {string}
 */
export const combineRefundPolicies = (workshops = []) => {
  const seen = new Set();
  const distinct = [];
  for (const workshop of workshops) {
    if (!workshop) continue;
    const key = workshop.workshopId ?? workshop.title ?? distinct.length;
    if (seen.has(key)) continue;
    seen.add(key);
    distinct.push({
      title: (workshop.title || '').trim(),
      refundPolicy: (workshop.refundPolicy || '').trim(),
    });
  }

  const withCustom = distinct.filter((w) => w.refundPolicy);
  if (withCustom.length === 0) return '';
  if (distinct.length === 1) return withCustom[0].refundPolicy;

  return distinct
    .map((w) => {
      const heading = w.title ? `# ${w.title}\n\n` : '';
      const body = w.refundPolicy
        ? w.refundPolicy
        : 'This workshop follows the standard Koready cancellation & refund policy.';
      return `${heading}${body}`;
    })
    .join('\n\n');
};
